// extracted by mini-css-extract-plugin
export var active = "_i7-7";
export var blink = "_i7-8";
export var dropDownSelector = "_i7-4";
export var dropDownWrapper = "_i7-3";
export var fakeCursor = "_i7-6";
export var fontSizeButton = "_i7-9";
export var formQuillEditor = "_i7-0";
export var pressed = "_i7-a";
export var qlBlank = "_i7-1";
export var textFormattingToolbar = "_i7-2";
export var textToolbarOption = "_i7-5";